import actions from './actions'

const initialState = { appId: null, invoices: [], paymentLink: '', isBillingHistoryLoading: false }

export default function billingHistoryReducer(prevState = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...prevState, ...action.payload }
    case actions.CLEAR_STATE:
      return initialState
    default:
      return prevState
  }
}
